export default {
  "app": {
    "name": "DeepTrade",
    "tagline": "Trading de Cryptomonnaies alimenté par l'IA",
    "description": "Signaux de trading avancés et gestion automatisée de portefeuille",
  },
  "navigation": {
    "dashboard": "Tableau de bord",
    "trading": "Trading",
    "signals": "Signaux",
    "apiCredentials": "Identifiants API",
    "autoTrading": "Trading Automatique",
    "tierManagement": "Gestion des Niveaux",
    "referrals": "Parrainages",
    "accessSecurity": "Accès et Sécurité",
    "settings": "Paramètres",
    "help": "Aide et Support",
    "login": "Connexion",
    "register": "S'inscrire",
    "logout": "Déconnexion",
    "home": "Accueil",
  },
  "auth": {
    "layout": {
      "signInToAccount": "Connectez-vous à votre compte",
      "or": "Ou",
      "createNewAccount": "créer un nouveau compte"
    },
    "login": {
      "title": "Bon Retour",
      "subtitle": "Entrez votre email et mot de passe pour vous connecter",
      "email": "Email",
      "password": "Mot de passe",
      "emailPlaceholder": "nom@exemple.com",
      "passwordPlaceholder": "••••••••",
      "rememberMe": "Se souvenir de moi",
      "forgotPassword": "Mot de passe oublié ?",
      "signIn": "Se connecter",
      "noAccount": "Vous n'avez pas de compte ?",
      "signUp": "S'inscrire",
      "googleSignIn": "Continuer avec Google",
      "orContinueWith": "Ou continuer avec",
      "fillAllFields": "Veuillez remplir tous les champs",
      "loginSuccess": "Connexion réussie !",
      "loginFailed": "Échec de la connexion",
      "loginFailedDescription": "Échec de la connexion",
      "googleLoginFailed": "Échec de l'initiation de la connexion Google",
      "bySigningIn": "En vous connectant, vous acceptez nos",
      "termsOfService": "Conditions d'Utilisation",
      "privacyPolicy": "Politique de Confidentialité",
      "and": "et"
    },
    "register": {
      "title": "Créer un Compte",
      "subtitle": "Entrez vos informations pour créer un compte",
      "firstName": "Prénom",
      "lastName": "Nom de famille",
      "email": "Adresse e-mail",
      "password": "Mot de passe",
      "confirmPassword": "Confirmer le mot de passe",
      "agreeTerms": "En cliquant sur continuer, vous acceptez nos",
      "createAccount": "Créer un compte",
      "hasAccount": "Vous avez déjà un compte ?",
      "signIn": "Se connecter",
      "orContinueWith": "Ou continuer avec",
      "googleSignUp": "S'inscrire avec Google",
      "termsOfService": "Conditions d'utilisation",
      "privacyPolicy": "Politique de confidentialité",
      "referralCode": "Code de Parrainage (Optionnel)",
      "placeholders": {
        "firstName": "Jean",
        "lastName": "Dupont",
        "email": "nom@exemple.com",
        "password": "Entrez votre mot de passe",
        "confirmPassword": "Confirmez votre mot de passe",
        "referralCode": "Entrez le code de parrainage"
      },
      "validation": {
        "minLength": "Le mot de passe doit contenir au moins 8 caractères",
        "uppercase": "Le mot de passe doit contenir au moins une lettre majuscule",
        "lowercase": "Le mot de passe doit contenir au moins une lettre minuscule",
        "number": "Le mot de passe doit contenir au moins un chiffre",
        "specialChar": "Le mot de passe doit contenir au moins un caractère spécial"
      },
      "errors": {
        "invalidReferralCode": "Code de parrainage invalide",
        "referralValidationFailed": "Impossible de valider le code de parrainage. Vérifiez votre connexion et réessayez.",
        "googleLoginFailed": "Échec de la connexion Google",
        "googleLoginFailedTitle": "Échec de la connexion Google",
        "fillAllFields": "Veuillez remplir tous les champs",
        "requirementsNotMet": "Exigences de Mot de Passe Non Respectées",
        "passwordsDoNotMatch": "Les mots de passe ne correspondent pas",
        "registrationFailed": "Échec de l'inscription",
        "failedToCreateAccount": "Échec de la création du compte",
        "emailAlreadyRegistered": "Email déjà enregistré",
        "emailAlreadyRegisteredDescription": "Un compte avec cette adresse email existe déjà. Veuillez essayer de vous connecter.",
        "connectionError": "Erreur de Connexion",
        "connectionErrorDescription": "Impossible de se connecter au serveur. Vérifiez votre connexion internet et réessayez.",
        "referralCodeError": "Erreur de Code de Parrainage",
        "referralCodeErrorDescription": "Il y a eu un problème lors du traitement de votre code de parrainage. Votre compte sera quand même créé.",
        "failedToResendEmail": "Échec du renvoi de l'email de vérification",
        "failedToResendEmailTitle": "Échec du renvoi de l'email",
        "tryAgainLater": "Veuillez réessayer plus tard."
      },
      "success": {
        "title": "Inscription Réussie !",
        "description": "Veuillez vérifier votre email pour vérifier votre compte."
      },
      "verification": {
        "title": "Vérifiez Votre Email",
        "description": "Nous avons envoyé un lien de vérification à {{email}}",
        "nextSteps": "Prochaines Étapes :",
        "step1": "1. Vérifiez votre boîte de réception",
        "step2": "2. Cliquez sur le lien de vérification",
        "step3": "3. Revenez ici pour vous connecter",
        "sending": "Envoi en cours...",
        "resendButton": "Renvoyer l'Email de Vérification",
        "backToLogin": "Retour à la Connexion",
        "emailSentTitle": "Email de Vérification Envoyé",
        "emailSentDescription": "Veuillez vérifier votre email pour le lien de vérification."
      },
      "referral": {
        "validating": "Validation du code de parrainage...",
        "validCode": "Code de parrainage valide de {{referrer}}"
      }
    },
    "passwordRequirements": {
      "title": "Exigences du mot de passe",
      "length": "Au moins 8 caractères",
      "uppercase": "Une lettre majuscule",
      "lowercase": "Une lettre minuscule",
      "number": "Un chiffre",
      "special": "Un caractère spécial",
    },
    "errors": {
      "invalidCredentials": "Email ou mot de passe invalide",
      "emailRequired": "Email requis",
      "passwordRequired": "Mot de passe requis",
      "passwordTooShort": "Le mot de passe doit contenir au moins 8 caractères",
      "passwordsNotMatch": "Les mots de passe ne correspondent pas",
      "emailInvalid": "Veuillez saisir une adresse email valide",
      "termsRequired": "Vous devez accepter les termes et conditions",
    }
  },
  "dashboard": {
    "title": "Tableau de bord",
    "welcome": "Bon retour !",
    "overview": "Aperçu",
    "trading": "Trading",
    "tier": "Niveau",
    "balance": "Solde",
    "pnlToday": "Profits et Pertes",
    "totalTrades": "Total des Trades",
    "winRate": "Taux de Réussite",
    "activeSignals": "Signaux Actifs",
    "tradingOverview": "Aperçu du Trading",
    "quickActions": "Actions Rapides",
    "viewSignals": "Voir les Signaux",
    "autoTrading": "Trading Automatique",
    "autoTradingDescription": "Exécuter automatiquement les signaux de trading",
    "currentTier": "Niveau Actuel",
    "progressTo": "Progression vers le Niveau {{tier},",
    "yourBenefits": "Vos Avantages",
    "advancedSignals": "Signaux de Trading Avancés",
    "autoTradingFeatures": "Fonctionnalités de Trading Automatique",
    "prioritySupport": "Support Prioritaire",
    "monthlyRate": "Taux Mensuel",
    "profitShare40": "40% de partage des bénéfices",
    "profitShare20": "20% de partage des bénéfices",
    "profitShare10": "10% de partage des bénéfices",
    "verifyingNFT": "Vérification de la propriété NFT...",
    "debt": "Dette",
    "btcPrice": {
      "symbol": "BTC/USDT",
      "loading": "BTC/USDT: Chargement...",
      "unavailable": "BTC/USDT: --",
      "connecting": "Connexion...",
      "live": "En Direct",
      "error": "Erreur ({{count}})",
      "24h": "24h",
    },
    "controls": {
      "turnOn": "Activer",
      "turnOff": "Désactiver",
      "paperAutoTrading": "Trading Automatique Papier",
    },
    "forecast": {
      "title": "Prévision des Prix",
      "refresh": "Actualiser",
      "errorLoading": "Erreur lors du chargement du graphique",
      "retry": "Réessayer",
      "noData": "Aucune donnée de graphique disponible",
    },
    "tradingChart": {
      "forecast": "Prévision",
      "upperBound": "Borne supérieure",
      "lowerBound": "Borne inférieure",
      "support": "Support",
      "resistance": "Résistance",
      "entry": "Entrée",
      "stopLoss": "Stop loss",
      "takeProfit": "Take profit",
      "partialTakeProfit": "TP partiel",
      "liquidation": "Liquidation",
      "locked": "Verrouillé",
      "positionLevelDialogTitle": "Confirmer la mise à jour de {{level}}",
      "positionLevelDialogDescription": "Définir {{level}} pour {{symbol}} {{side}} de {{currentPrice}} à {{newPrice}} ?",
      "positionLevelDelta": "Variation : {{delta}} %",
      "positionLevelConfirm": "Mettre à jour {{level}}",
      "positionLevelCancel": "Annuler",
      "positionLevelProcessing": "Mise à jour...",
      "positionLevelSuccess": "{{level}} mis à jour",
      "positionLevelSuccessDesc": "{{symbol}} {{side}} · nouveau {{level}} : {{price}}",
      "positionLevelFailure": "Échec de la mise à jour de {{level}}",
      "positionLevelFailureDesc": "Le niveau précédent a été restauré. {{error}}",
      "dragHint": "Glissez pour déplacer · relâchez pour confirmer",
      "indicators": {
        "title": "Indicateurs",
        "overlays": "Superpositions",
        "panes": "Panneaux",
        "levels": "Niveaux",
        "keyLevels": "Niveaux clés (S/R)",
        "reset": "Réinitialiser les indicateurs",
        "ema20": "EMA 20",
        "ema50": "EMA 50",
        "ema200": "EMA 200",
        "sma20": "SMA 20",
        "sma50": "SMA 50",
        "bb20": "Bandes de Bollinger (20, 2)",
        "bbUpper": "Bollinger supérieure",
        "bbMiddle": "Bollinger médiane",
        "bbLower": "Bollinger inférieure",
        "vwap": "VWAP",
        "rsi14": "RSI (14)",
        "macd": "MACD (12, 26, 9)",
        "macdSignal": "Signal MACD",
      },
      "drawing": {
        "toolbar": "Outils de dessin",
        "select": "Sélectionner",
        "magnetMode": "Aimant : {{mode}}",
        "stayInDrawingMode": "Rester en mode dessin",
        "hideAll": "Masquer tous les dessins",
        "showAll": "Afficher tous les dessins",
        "undo": "Annuler",
        "redo": "Rétablir",
        "deleteSelected": "Supprimer les dessins sélectionnés",
        "clearAll": "Effacer tous les dessins",
        "moreTools": "Plus d'outils de dessin",
        "export": "Exporter les dessins",
        "import": "Importer les dessins",
        "textPrompt": "Saisir le texte du dessin",
        "loadFailure": "Outils de dessin indisponibles",
        "importEmpty": "Aucun dessin trouvé dans ce fichier",
        "importSuccess": "{{count}} dessins importés",
        "importFailure": "Impossible d'importer les dessins",
        "clearConfirmTitle": "Effacer tous les dessins ?",
        "clearConfirmDescription": "Cela supprime tous les dessins du symbole et de la période actuels. Cette action est irréversible.",
        "categories": {
          "lines": "Lignes",
          "channels": "Canaux",
          "fibonacci": "Fibonacci et Gann",
          "patterns": "Motifs",
          "elliott": "Elliott",
          "forecasting": "Prévision et mesure",
          "volume": "Volume",
          "annotations": "Annotations",
          "shapes": "Formes",
          "cycles": "Cycles",
          "regression": "Régression",
        },
        "tools": {
          "trend-line": "Ligne de tendance",
          "horizontal-line": "Ligne horizontale",
          "vertical-line": "Ligne verticale",
          "ray": "Rayon",
          "parallel-channel": "Canal parallèle",
          "fib-retracement": "Retracement de Fib",
          "trend-based-fib-extension": "Extension de Fib par tendance",
          "rectangle": "Rectangle",
          "text": "Texte",
          "arrow": "Flèche",
          "brush": "Pinceau",
          "price-range": "Plage de prix",
          "long-position": "Position longue",
          "short-position": "Position courte",
        },
      },
    },
    "realTimePerformance": "Performance en Temps Réel",
    "riskSettings": {
      "title": "Paramètres de Gestion des Risques",
      "paperTradingTitle": "Paramètres de Gestion des Risques - Trading de Démonstration",
      "loading": "Chargement des paramètres de risque...",
      "investmentPercentage": "Pourcentage d'Investissement",
      "investmentDescription": "Pourcentage du solde à utiliser pour le trading (0% - 10%)",
      "leverage": "Effet de Levier",
      "leverageDescription": "Max: {{max}}x pour Niveau {{tier}} + {{exchange}} {{market},",
      "paperTradingLeverageDesc": "En mode démonstration, vous pouvez utiliser n'importe quel paramètre d'effet de levier à des fins de test",
      "exchange": "Exchange: ",
      "configureCredentials": "Configurer dans les Identifiants API",
      "warningZeroInvestment": "Sélectionnez un pourcentage d'investissement > 0% pour activer le trading",
      "paperTradingNote": "Mode trading de démonstration - aucune limitation de niveau ne s'applique",
      "saveSettings": "Enregistrer les Paramètres",
      "saving": "Enregistrement...",
      "resetToSafe": "Réinitialiser en Mode Sécurisé",
      "confirmSaveTitle": "Confirmer les Paramètres de Risque",
      "confirmSaveDesc": "Êtes-vous sûr de vouloir sauvegarder ces paramètres de risque ?\n\nInvestissement : {{investment}}%\nLevier : {{leverage}}x\nMode : {{mode}}",
      "confirmSave": "Sauvegarder les Paramètres",
      "saveSuccess": "Paramètres Sauvegardés",
      "saveSuccessDesc": "Vos paramètres de gestion des risques ont été sauvegardés avec succès.",
      "saveError": "Échec de la Sauvegarde",
      "tradingStrategy": "Stratégie de Trading",
      "strategyActive": "Stratégie Standard",
      "strategyConservative": "Stratégie Neural AI",
      "strategyActiveBadge": "Recommandé",
      "strategyActiveDesc": "Trades plus fréquents basés sur des prédictions de prix ML. Génère 3 à 8 signaux par jour avec 75-80 % de précision attendue. Idéal pour les traders qui veulent plus d'opportunités et peuvent gérer une activité modérée.",
      "strategyConservativeDesc": "Moins de trades mais avec une confiance plus élevée et des confirmations strictes. Génère 1 à 3 signaux par jour avec 85-90 % de précision attendue. Idéal pour les traders conservateurs qui privilégient la qualité à la quantité.",
      "gridTradingTitle": "Grid Trading",
      "gridEnabledLabel": "Activer le Grid Trading",
      "trailingStopTitle": "Trailing Stop",
      "trailingStopEnabledLabel": "Activer le Trailing Stop",
      "signalsPerDay": "Signaux par Jour",
      "expectedAccuracy": "Précision Attendue",
      "tradeFrequency": "Fréquence de Trading",
      "riskLevel": "Niveau de Risque",
      "profitPotential": "Potentiel de Profit",
      "bestFor": "Idéal Pour",
      "activeTraders": "Traders actifs qui veulent plus d'opportunités",
      "conservativeTraders": "Traders conservateurs qui préfèrent la qualité à la quantité",
      "high": "Élevé",
      "low": "Faible",
      "moderate": "Modéré",
      "higher": "Plus élevé",
      "viewComparison": "Voir la Comparaison",
      "hideComparison": "Masquer la Comparaison",
      "testForecastStrategy": "Tester la Stratégie de Prévision",
      "testingStrategy": "Test de la Stratégie...",
      "testStrategyDesc": "Cliquez pour tester si la stratégie de prévision ouvrirait un trade maintenant",
      "paperSettingsError": "Erreur des Paramètres Papier",
      "paperSettingsErrorDesc": "Échec du chargement des paramètres de risque du trading papier.",
      "settingsLoadError": "Erreur de Chargement des Paramètres",
      "settingsLoadErrorDesc": "Échec du chargement des paramètres de risque. Veuillez actualiser la page.",
      "configurationRequired": "Configuration Requise",
      "configurationRequiredDesc": "Veuillez définir un pourcentage d'investissement supérieur à 0% avant de tester la stratégie.",
      "noTradeSignal": "Aucun Signal de Trading",
      "noTradeSignalDesc": "La prévision montre un mouvement insuffisant. Haussier: {{upward}}%, Baissier: {{downward}}%. Besoin de >0,5% pour déclencher le trading.",
      "strategyTestSuccessful": "Test de Stratégie Réussi",
      "strategyTestSuccessfulDesc": "Signal {{direction}} détecté avec {{movement}}% de mouvement potentiel. {{result}}",
      "paperTradeOpened": "Trade papier ouvert avec succès!",
      "tradeSimulationCompleted": "Simulation de trade terminée.",
      "strategyTestFailed": "Test de Stratégie Échoué",
      "strategyTestFailedDesc": "Erreur inconnue survenue pendant le test de stratégie.",
      "strategyTestError": "Erreur de Test de Stratégie",
      "strategyTestErrorDesc": "Échec du test de la stratégie de prévision.",
    },
    "activePositions": {
      "title": "Positions Actives",
      "tabs": {
        "all": "toutes",
        "app": "app",
        "external": "externes",
      },
      "refresh": "Actualiser",
      "errorLoading": "Erreur de chargement des positions actives",
      "retry": "Réessayer",
      "noPositions": "Aucune position active.",
      "noPositionsDesc": "Vos positions de trading actives apparaîtront ici une fois que vous commencerez à trader ou activerez le trading automatique.",
      "noAppPositions": "Aucune position active de l'app.",
      "noExternalPositions": "Aucune position externe active.",
      "addCredentialsWarning": " Ajoutez des identifiants API pour voir les positions externes",
      "externalError": "❌ Erreur des positions externes: {{error},",
      "externalErrorGeneric": "❌ {{error},",
      "diagnostics": "App: {{app}} | Externes: {{external},",
      "fields": {
        "size": "Taille",
        "entryPrice": "Prix d'Entrée",
        "currentPrice": "Prix Actuel",
        "margin": "Marge",
        "liquidationPrice": "Prix de Liquidation",
        "marginRate": "Taux de Marge",
        "takeProfit": "TP",
        "stopLoss": "SL",
        "roi": "ROE",
        "none": "Aucun",
        "na": "N/A",
      },
      "positionTypes": {
        "appPositions": "Positions de l'App",
        "externalPositions": "Positions Externes",
      },
      "headers": {
        "symbol": "Symbole",
        "size": "Taille",
        "entryPrice": "Prix d'Entrée",
        "markPrice": "Prix de Marque",
        "liqPrice": "Prix de Liq.",
        "margin": "Marge",
        "pnlRoi": "PNL (ROE %)",
        "tpSl": "TP/SL",
        "actions": "Actions",
      },
      "close": "Fermer",
      "closing": "Fermeture...",
      "featureNotAvailable": "Fonctionnalité Non Disponible",
      "positionClosingPaperOnly": "La fermeture de positions n'est actuellement disponible qu'en mode Trading Papier.",
      "tpSlPaperOnly": "TP/SL n'est actuellement disponible qu'en mode Trading Papier.",
      "positionClosed": "Position Fermée",
      "positionClosedDesc": "Position fermée avec succès. PnL: ${{pnl}}",
      "errorClosingPosition": "Erreur de Fermeture de Position",
      "errorClosingPositionDesc": "Échec de la fermeture de position",
      "takeProfitSet": "Take Profit Défini",
      "takeProfitSetDesc": "Take profit défini à ${{price}}",
      "errorSettingTakeProfit": "Erreur de Définition du Take Profit",
      "errorSettingTakeProfitDesc": "Échec de la définition du Take Profit",
      "stopLossSet": "Stop Loss Défini",
      "stopLossSetDesc": "Stop loss défini à ${{price}}",
      "errorSettingStopLoss": "Erreur de Définition du Stop Loss",
      "errorSettingStopLossDesc": "Échec de la définition du Stop Loss",
      "position": "position",
      "positions": "positions",
      "allPositions": "Toutes les Positions",
      "noApiCredentials": "Aucune identifiant API connecté",
    },
    "debug": {
      "testSuccessful": "Test de Trading Debug Réussi",
      "paperTradeOpened": "Trade papier ouvert avec succès!",
      "tradeSimulationCompleted": "Simulation de trade terminée.",
      "testFailed": "Test de Trading Debug Échoué",
      "unknownError": "Erreur inconnue survenue pendant le test de trading debug.",
      "testError": "Erreur de Test Debug",
      "testErrorDesc": "Échec du test d'ouverture de trade.",
    },
    "profitShare": {
      "title": "Suivi du Partage des Bénéfices",
      "loading": "Chargement des données de partage des bénéfices...",
      "noData": "Aucune donnée de partage des bénéfices disponible. Commencez à trader pour suivre vos bénéfices.",
      "balanceOverview": "Aperçu du Solde",
      "initialBalance": "Solde Initial:",
      "currentBalance": "Solde Actuel:",
      "netDeposits": "Dépôts Nets:",
      "profitAnalysis": "Analyse des Bénéfices",
      "tradingProfit": "Bénéfice de Trading:",
      "trueProfit": "Bénéfice Réel:",
      "profitPercentage": "% de Bénéfice:",
      "profitShareInfo": "Partage des Bénéfices",
      "tierRate": "Taux Niveau {{tier}}:",
      "amountOwed": "Montant Dû:",
      "status": "Statut:",
      "profitable": "Le compte est rentable - Le partage des bénéfices s'applique aux gains au-dessus du solde initial",
      "notProfitable": "Le compte n'est pas encore rentable - Pas de partage des bénéfices jusqu'à ce que le solde dépasse l'initial + dépôts",
      "profitableDescription": "Votre solde est supérieur à votre capital initial et à vos dépôts. Les frais de partage des bénéfices seront calculés sur les gains indiqués ci-dessus.",
      "notProfitableDescription": "Continuez à trader pour dépasser votre capital initial plus vos dépôts. D'ici là, aucun partage des bénéfices n'est dû.",
      "paymentRequired": "Paiement Requis",
      "paymentDescription": "Vous avez ${{amount}} en frais de partage des bénéfices à payer.",
      "payNow": "Payer Maintenant",
      "viewDetails": "Voir les détails du partage des bénéfices",
    },
    "tradingHistory": {
      "title": "Historique de Trading (Trades de l'App Uniquement)",
      "description": "Affichage des trades initiés par la plateforme DeepTrade",
      "loading": "Chargement...",
      "headers": {
        "date": "Date",
        "symbol": "Symbole",
        "side": "Côté",
        "size": "Taille",
        "entry": "Entrée",
        "exit": "Sortie",
        "fees": "Frais",
        "pnl": "P&L Brut",
        "status": "Statut",
      },
      "noHistory": "Aucun historique de trading trouvé. Commencez à trader pour voir votre historique ici.",
      "pagination": "Page {{page}} sur {{pages}} ({{total}} trades au total)",
      "previous": "Précédent",
      "next": "Suivant",
    },
    "blockedUser": {
      "title": "Trading Bloqué:",
      "message": "Partage des bénéfices impayé pour votre niveau ({{tier}}). Dû: ${{owed}}. Veuillez régler votre solde pour continuer.",
    },
    "tooltips": {
      "balance": "Votre solde de compte actuel de votre exchange connecté.",
      "pnlToday": "Profit et perte réalisés des transactions fermées aujourd'hui.",
      "monthlyRate": "Votre taux de rendement mensuel en pourcentage.",
      "winRate": "Pourcentage de vos transactions qui étaient rentables."
    }
  },
  "trading": {
    "title": "Trading",
    "signals": "Signaux",
    "positions": "Positions",
    "history": "Historique",
    "long": "Long",
    "short": "Short",
    "autoTrading": "Trading Automatique",
    "autoTradingActive": "Trading Automatique Actif",
    "autoTradingDisabled": "Trading Automatique Désactivé",
    "autoTradingActiveDesc": "Les signaux seront exécutés automatiquement",
    "autoTradingDisabledDesc": "Activez pour exécuter automatiquement les signaux de trading",
    "noActiveSignals": "Aucun Signal Actif",
    "waitingForSignals": "En attente de nouvelles opportunités de trading...",
    "enableAutoTrading": "Activez le trading automatique pour recevoir des signaux",
    "refreshSignals": "Actualiser les Signaux",
    "noOpenPositions": "Aucune Position Ouverte",
    "positionsDesc": "Vos positions de trading actives apparaîtront ici",
    "noTradingHistory": "Aucun Historique de Trading",
    "historyDesc": "Vos trades terminés apparaîtront ici",
    "executeTradeButton": "Exécuter le Trade",
    "viewDetailsButton": "Voir les Détails",
    "entry": "Entrée",
    "stopLoss": "Stop Loss",
    "takeProfit": "Take Profit",
    "confidence": "{{value}}% de confiance",
    "strategy": "Stratégie",
    "firstTp": "Premier TP",
    "secondTp": "Deuxième TP",
    "autoMoveStopLoss": "Déplacer automatiquement le SL au seuil de rentabilité après le premier TP",
    "tradingMode": "Mode de Trading",
    "paperMode": "Démo",
    "liveMode": "Live",
    "paperTradingActive": "Trading de Démonstration Actif",
    "liveTradingActive": "Trading Live Actif",
    "paperTradingDesc": "Pratiquez le trading avec des fonds virtuels",
    "liveTradingDesc": "Tradez avec de l'argent réel",
    "virtualBalance": "Solde Virtuel",
    "unrealizedPnL": "P&L Non Réalisé",
    "equity": "Capitaux Propres",
    "paperTradingHelp": "Aide Trading de Démonstration",
    "resetAccount": "Réinitialiser le Compte",
    "paperTradingGuide": "Guide du Trading de Démonstration",
    "paperModeTitle": "Mode Démonstration",
    "noProfitSharePaper": "Pas de partage de profits en mode démonstration",
    "paperTradingPositions": "Total des Positions:",
    "paperTradingHistory": "Historique du Trading de Démonstration",
    "simulatedTradingHistory": "Historique de trading simulé",
    "noPaperPositions": "Aucune position de trading de démonstration",
    "enableAutoTradingPaper": "Le trading de démonstration générera automatiquement des positions simulées basées sur les signaux du marché",
    "paperTradingMode": "Mode Trading de Démonstration",
    "autoTradingNotAvailable": "Trading Automatique Non Disponible",
    "autoTradingDisabledPaper": "Le trading automatique contrôle le trading live. Le trading de démonstration génère automatiquement des signaux.",
    "riskManagement": "Gestion des Risques",
    "riskSettings": "Paramètres de Risque",
    "investmentPercentage": "Pourcentage d'Investissement",
    "leverage": "Effet de Levier",
    "maxLeverage": "Effet de Levier Maximum",
    "currentTier": "Niveau Actuel",
    "exchange": "Exchange",
    "accountType": "Type de Compte",
    "marketType": "Type de Marché",
    "saveSettings": "Sauvegarder les Paramètres",
    "resetToSafe": "Réinitialiser en Sécurité",
    "saving": "Sauvegarde...",
    "riskSettingsSaved": "Paramètres de risque sauvegardés avec succès",
    "failedToSaveRiskSettings": "Échec de la sauvegarde des paramètres de risque",
    "position": "position",
    "internal": "Interne",
    "external": "Externe",
    "marketClose": "Fermeture Marché",
    "reverse": "Inverser",
    "editTpSl": "TP/SL",
    "refreshActivePositions": "Actualiser les Positions Actives",
    "youHaveNoPosition": "Vous n'avez aucune position.",
    "noActiveAppPositions": "Aucune position active de l'app trouvée.",
    "noActiveExternalPositions": "Aucune position externe active trouvée.",
    "yourActivePositionsWillAppear": "Vos positions de trading actives apparaîtront ici.",
    "previous": "Précédent",
    "next": "Suivant",
    "learnMore": "En Savoir Plus",
    "paperTradingLabel": "Trading de Démonstration",
    "recentPaperTrades": "Trades de Démonstration Récents",
    "noPaperTrades": "Pas encore de trades de démonstration",
    "paperTradingAutoGenerate": "Le trading de démonstration générera automatiquement des trades simulés basés sur les signaux du marché",
    "activePositionsTitle": "Positions Actives",
    "youHaveNoPositions": "Vous n'avez aucune position.",
    "yourActivePositionsWillAppearHere": "Vos positions de trading actives apparaîtront ici une fois que vous commencerez à trader ou activerez le trading automatique.",
    "max": "Max",
    "tooltips": {
      "virtualBalance": "Votre solde réalisé des transactions fermées. Calculé comme : Solde Initial + P&L Net Total de toutes les transactions fermées.",
      "unrealizedPnL": "Profit ou perte de vos positions actuellement ouvertes. Cette valeur change en temps réel en fonction des prix actuels du marché et n'est pas encore réalisée.",
      "equity": "La valeur totale de votre compte incluant les positions ouvertes. Calculé comme : Solde Virtuel + P&L Non Réalisé. Cela représente votre valeur nette actuelle en trading de démonstration.",
      "profitAndLoss": "Profit et perte réalisés uniquement des transactions fermées. Cela n'inclut pas le P&L non réalisé des positions ouvertes.",
      "balance": "Votre solde de compte actuel disponible pour le trading.",
      "pnlToday": "Profit et perte réalisés des transactions fermées aujourd'hui.",
      "monthlyRate": "Votre taux de rendement mensuel calculé en pourcentage de votre solde initial.",
      "winRate": "Pourcentage de transactions fermées qui étaient rentables. Calculé uniquement à partir des transactions terminées.",
      "totalReturn": "Votre pourcentage de rendement total basé sur le Solde Virtuel. Calculé comme : (Solde Virtuel Actuel - Solde Initial) / Solde Initial × 100%."
    }
  },
  "common": {
    "loading": "Chargement...",
    "error": "Erreur",
    "success": "Succès",
    "save": "Sauvegarder",
    "cancel": "Annuler",
    "yes": "Oui",
    "no": "Non",
    "active": "Actif",
    "inactive": "Inactif",
    "on": "ACTIVÉ",
    "off": "DÉSACTIVÉ",
    "enabled": "activé",
    "disabled": "désactivé",
    "for": "pour",
    "warning": "Warning",
    "info": "Information",
    "confirm": "Confirmer",
    "edit": "Edit",
    "delete": "Delete",
    "close": "Fermer",
    "back": "Retour",
    "next": "Suivant",
    "previous": "Précédent",
    "submit": "Submit",
    "reset": "Reset",
    "search": "Search",
    "filter": "Filter",
    "sort": "Sort",
    "refresh": "Refresh",
    "enable": "Activer",
    "disable": "Désactiver",
    "toggleOn": "ON",
    "toggleOff": "OFF",
    "ok": "OK",
    "apply": "Appliquer",
    "clear": "Effacer",
    "select": "Sélectionner",
    "upload": "Téléverser",
    "download": "Télécharger",
    "copy": "Copier",
    "copied": "Copié !",
    "share": "Share",
    "print": "Imprimer",
    "export": "Export",
    "import": "Import",
    "and": "et"
  },
  "wallet": {
    "connect": "Connecter le Portefeuille",
    "disconnect": "Déconnecter",
    "connected": "Connecté",
    "notConnected": "Non Connecté",
    "connecting": "Connexion...",
    "balance": "Solde",
    "address": "Adresse",
    "solanaBlockchain": "Alimenté par la Blockchain Solana",
    "solanaTooltip": "Construit sur Solana - Blockchain rapide, sécurisée et évolutive",
    "wrongNetwork": "Mauvais Réseau",
    "switchNetwork": "Changer de Réseau",
    "transactionPending": "Transaction en Attente",
    "transactionConfirmed": "Transaction Confirmée",
    "transactionFailed": "Transaction Échouée",
    "connectionError": "Erreur de Connexion",
    "connectionFailed": "Échec de la connexion du portefeuille",
    "connectionRejected": "La connexion du portefeuille a été rejetée",
    "walletNotFound": "Aucun portefeuille Solana trouvé. Veuillez installer un portefeuille comme Phantom.",
    "disconnected": "Portefeuille Déconnecté",
    "disconnectedSuccess": "Votre portefeuille a été déconnecté avec succès.",
    "disconnectError": "Erreur de Déconnexion",
    "disconnectFailed": "Échec de la déconnexion du portefeuille.",
    "confirmDisconnect": "Confirmer la Déconnexion du Portefeuille",
    "confirmDisconnectMessage": "Êtes-vous sûr de vouloir déconnecter votre portefeuille ?",
  },
  "notifications": {
    "autoTradingEnabled": "Le trading automatique a été activé",
    "autoTradingDisabled": "Le trading automatique a été désactivé",
    "settingsSaved": "Paramètres sauvegardés avec succès",
    "passwordChanged": "Mot de passe modifié avec succès",
    "profileUpdated": "Profil mis à jour avec succès",
    "walletConnected": "Portefeuille connecté avec succès",
    "walletDisconnected": "Portefeuille déconnecté",
    "signalExecuted": "Signal de trading exécuté",
    "tradeCompleted": "Transaction terminée avec succès",
    "paymentSuccessful": "Paiement traité avec succès",
    "tierUpgraded": "Niveau mis à jour avec succès",
    "autoTrading": {
      "enabledTitle": "Trading Automatique Activé",
      "enabledDescription": "Le trading automatique a été activé avec succès. Exigence de solde vérifiée.",
      "disabledTitle": "Trading Automatique Désactivé",
      "disabledDescription": "Le trading automatique a été désactivé avec succès.",
      "insufficientBalanceTitle": "Solde Insuffisant",
      "insufficientBalanceDescription": "Solde minimum de {{required}} USDT requis. Votre solde actuel est de {{current}} USDT.",
      "missingCredentialsTitle": "Identifiants API Manquants",
      "missingCredentialsDescription": "Veuillez d'abord ajouter et valider vos identifiants API d'exchange.",
      "balanceVerificationFailedTitle": "Vérification du Solde Échouée",
      "balanceVerificationFailedDescription": "Échec de la vérification du solde du compte. Veuillez vérifier vos identifiants API.",
      "errorTitle": "Erreur de Trading Automatique",
      "errorDescription": "Échec du basculement du trading automatique. Veuillez réessayer.",
      "systemDisabledTitle": "Trading Automatique Désactivé",
      "noApiCredentialsReason": "Aucune identifiant API d'exchange configuré. Veuillez ajouter vos clés API.",
      "investmentPercentageReason": "Le pourcentage d'investissement est défini à 0%. Veuillez ajuster vos paramètres de risque.",
    },
    "paperAutoTrading": {
      "enabledTitle": "Trading Automatique Papier Activé",
      "enabledDescription": "Les signaux de trading papier seront maintenant exécutés automatiquement",
      "disabledTitle": "Trading Automatique Papier Désactivé",
      "disabledDescription": "Les signaux de trading papier ne seront plus exécutés automatiquement",
      "errorTitle": "Erreur de Trading Automatique Papier",
      "errorDescription": "Échec du basculement du trading automatique papier"
    }
  },
  "pagination": {
    "show": "Afficher",
    "perPage": "par page",
    "showing": "Affichage de {{start}} à {{end}} sur {{total}} entrées",
    "previous": "Précédent",
    "next": "Suivant"
  },
  "errors": {
    "generic": "Quelque chose s'est mal passé. Veuillez réessayer.",
    "network": "Erreur réseau. Veuillez vérifier votre connexion.",
    "unauthorized": "Vous n'êtes pas autorisé à effectuer cette action.",
    "forbidden": "Accès refusé.",
    "notFound": "La ressource demandée n'a pas été trouvée.",
    "serverError": "Erreur serveur. Veuillez réessayer plus tard.",
    "validationError": "Veuillez vérifier votre saisie et réessayer.",
    "walletNotConnected": "Veuillez d'abord connecter votre portefeuille.",
    "insufficientBalance": "Solde insuffisant.",
    "transactionFailed": "Transaction échouée. Veuillez réessayer.",
    "apiError": "Erreur API. Contactez le support si cela persiste.",
  },
  "settings": {
    "title": "Paramètres de Compte",
    "pleaseLogIn": "Veuillez Vous Connecter",
    "loginRequired": "Vous devez être connecté pour accéder aux paramètres du compte.",
    "goToLogin": "Aller à la Connexion",
    "profile": {
      "title": "Paramètres de Profil",
      "description": "Gérez les informations et préférences de votre compte",
      "email": "Adresse Email",
      "currentEmail": "Email Actuel",
      "newEmail": "Nouvelle Adresse Email",
      "updateEmail": "Mettre à jour l'Email",
      "sending": "Envoi...",
      "placeholders": {
        "newEmail": "Entrez votre nouvelle adresse email",
        "currentPassword": "Entrez votre mot de passe actuel"
      }
    },
    "security": {
      "title": "Paramètres de Sécurité",
      "description": "Gérez votre mot de passe et préférences de sécurité",
      "changePassword": "Changer le Mot de Passe",
      "currentPassword": "Mot de Passe Actuel",
      "newPassword": "Nouveau Mot de Passe",
      "confirmPassword": "Confirmer le Nouveau Mot de Passe",
      "enable2FA": "Authentification à Deux Facteurs",
      "twoFactorEnabled": "L'authentification à deux facteurs est activée pour votre compte",
      "twoFactorDisabled": "L'authentification à deux facteurs est désactivée pour votre compte",
      "changing": "Changement...",
      "changePasswordButton": "Changer le Mot de Passe",
      "verificationCode": "Code de Vérification",
      "verifyCode": "Vérifier le Code",
      "verifying": "Vérification...",
      "cancel": "Annuler",
      "disable2FA": "Désactiver l'Authentification à Deux Facteurs",
      "disable2FADescription": "Êtes-vous sûr de vouloir désactiver 2FA ? Cela rendra votre compte moins sécurisé. Nous enverrons un code de vérification à votre email pour confirmer cette action.",
      "sendVerificationCode": "Envoyer le Code de Vérification",
      "disabling": "Désactivation...",
      "disable2FAButton": "Désactiver 2FA",
      "resendCode": "Renvoyer le Code",
      "verifyEmail": "Vérifiez Votre Email",
      "verifyEmailDescription": "Nous avons envoyé un code de vérification à 6 chiffres à votre email. Entrez-le ci-dessous pour activer 2FA.",
      "verifyEmailToDisable2FA": "Vérifiez l'Email pour Désactiver 2FA",
      "verifyEmailToDisable2FADescription": "Nous avons envoyé un code de vérification à 6 chiffres à votre email. Entrez-le ci-dessous pour désactiver l'authentification à deux facteurs.",
      "placeholders": {
        "currentPassword": "Entrez votre mot de passe actuel",
        "newPassword": "Entrez votre nouveau mot de passe",
        "confirmPassword": "Confirmez votre nouveau mot de passe",
        "verificationCode": "Entrez le code à 6 chiffres"
      }
    },
    "account": {
      "title": "Zone de Danger",
      "deleteAccount": "Supprimer le Compte",
      "deleteAccountWarning": "Une fois que vous supprimez votre compte, il n'y a pas de retour en arrière. Veuillez être sûr.",
      "deleteAccountButton": "Supprimer le Compte",
      "deleting": "Suppression...",
      "deleteAccountModal": {
        "title": "Supprimer le Compte",
        "description": "Cette action ne peut pas être annulée. Cela supprimera définitivement votre compte et supprimera toutes les données associées.",
        "confirmText": "Supprimer le Compte",
        "typedConfirmationText": "SUPPRIMER",
        "permanentlyDelete": "Cela supprimera définitivement :",
        "consequences": [
          "Supprimer toutes vos données définitivement",
          "Supprimer votre historique de trading",
          "Annuler les abonnements actifs",
          "Supprimer tous les identifiants API",
          "Supprimer tous les paramètres et préférences"
        ]
      }
    },
    "errors": {
      "fillAllFields": "Veuillez remplir tous les champs",
      "passwordsNotMatch": "Les nouveaux mots de passe ne correspondent pas",
      "invalidVerificationCode": "Veuillez entrer le code de vérification",
      "invalid6DigitCode": "Veuillez entrer un code de vérification valide à 6 chiffres",
      "updateEmailFailed": "Échec de la mise à jour de l'email",
      "changePasswordFailed": "Échec du changement de mot de passe",
      "enable2FAFailed": "Échec de l'activation de 2FA",
      "verify2FAFailed": "Échec de la vérification du code 2FA",
      "disable2FAFailed": "Échec de l'envoi du code de vérification pour désactiver",
      "disable2FAVerifyFailed": "Échec de la désactivation de 2FA",
      "deleteAccountFailed": "Échec de la suppression du compte"
    },
    "success": {
      "verificationEmailSent": "Email de Vérification Envoyé",
      "verificationEmailDescription": "Veuillez vérifier {{email}} pour les instructions de vérification.",
      "passwordChanged": "Mot de Passe Changé",
      "passwordChangedDescription": "Votre mot de passe a été mis à jour avec succès.",
      "2FACodeSent": "Code 2FA Envoyé",
      "2FACodeSentDescription": "Veuillez vérifier votre email pour le code de vérification.",
      "2FAEnabled": "2FA Activé",
      "2FAEnabledDescription": "L'authentification à deux facteurs a été activée avec succès.",
      "verificationCodeSent": "Code de Vérification Envoyé",
      "verificationCodeSentDescription": "Veuillez vérifier votre email pour le code de vérification à 6 chiffres pour désactiver 2FA.",
      "2FADisabled": "2FA Désactivé",
      "2FADisabledDescription": "L'authentification à deux facteurs a été désactivée avec succès.",
      "accountDeleted": "Compte Supprimé",
      "accountDeletedDescription": "Votre compte a été supprimé avec succès."
    }
  },
  "accessSecurity": {
    "title": "Accès et Sécurité",
    "subtitle": "Surveillez la sécurité de votre compte et l'activité de connexion",
    "totalLogins": "Total des Connexions",
    "successRate": "Taux de Réussite",
    "uniqueIPs": "IPs Uniques",
    "twoFactorStatus": "Statut 2FA",
    "enabled": "Activé",
    "disabled": "Désactivé",
    "currentSession": "Session Actuelle",
    "currentSessionDescription": "Informations sur votre session de connexion actuelle",
    "recentLoginActivity": "Activité de Connexion Récente",
    "recentLoginDescription": "Vos tentatives de connexion et sessions récentes",
    "refresh": "Actualiser",
    "ipAddress": "Adresse IP",
    "timestamp": "Horodatage",
    "status": "Statut",
    "userAgent": "Agent Utilisateur",
    "successful": "Réussi",
    "failed": "Échoué",
    "noLoginActivity": "Aucune activité de connexion trouvée",
    "currentDevice": "Appareil Actuel",
    "location": "Emplacement",
    "sessionStart": "Début de Session",
    "lastLoginActivity": "Dernière Activité de Connexion",
    "lastLoginDescription": "Votre dernière connexion réussie",
    "loginTime": "Heure de Connexion",
    "browser": "Navigateur",
    "lastThirtyDays": "30 derniers jours",
    "loginSuccessRate": "Taux de réussite de connexion",
    "differentLocations": "Emplacements différents",
    "never": "Jamais",
    "unknown": "Inconnu",
    "reason": "Raison :",
    "authenticationRequired": "Authentification Requise",
    "authenticationRequiredDescription": "Veuillez vous connecter pour voir vos informations de sécurité.",
    "errors": {
      "authenticationError": "Erreur d'Authentification",
      "authenticationErrorDescription": "Veuillez vous reconnecter pour voir les données de sécurité.",
      "networkError": "Erreur Réseau",
      "networkErrorDescription": "Échec de récupération des données de sécurité. Veuillez vérifier votre connexion.",
      "refreshFailed": "Échec de l'actualisation",
      "refreshFailedDescription": "Échec de l'actualisation des données de sécurité. Veuillez réessayer."
    },
    "success": {
      "dataRefreshed": "Données de sécurité actualisées",
      "dataRefreshedDescription": "Vos informations de sécurité ont été mises à jour avec succès."
    }
  },
  "tiers": {
    "title": "Gestion des Niveaux",
    "currentTier": "Niveau Actuel",
    "choosePlan": "Choisissez Votre Plan",
    "tier1": {
      "name": "Niveau 1",
      "subtitle": "Gratuit",
      "description": "Parfait pour commencer avec des signaux de trading de base",
      "features": [
        "Signaux de trading de base",
        "Exécution manuelle des transactions",
        "Support communautaire",
        "Analyse de marché de base"
      ]
    },
    "tier2": {
      "name": "Niveau 2",
      "subtitle": "Accès 30 jours",
      "description": "Fonctionnalités avancées pour les traders sérieux",
      "features": [
        "Signaux de trading IA avancés",
        "Capacités de trading automatique",
        "Support prioritaire",
        "Analyses avancées",
        "Outils de gestion des risques"
      ]
    },
    "tier3": {
      "name": "Niveau 3",
      "subtitle": "NFT Requis",
      "description": "Niveau premium avec des fonctionnalités exclusives",
      "features": [
        "Signaux de trading premium",
        "Trading automatique avancé",
        "Support VIP",
        "Insights de marché exclusifs",
        "Stratégies personnalisées"
      ]
    },
    "activate": "Activer",
    "current": "Actuel",
    "paymentRequired": "Paiement Requis",
    "nftRequired": "NFT Requis",
    "membershipStatus": "Statut d'Adhésion",
    "active": "Actif",
    "expired": "Expiré",
    "daysRemaining": "Jours restants",
    "expiresOn": "Expire le",
  },
  "apiCredentials": {
    "title": "Identifiants API",
    "description": "Gérez vos identifiants API d'échange pour le trading",
    "addCredentials": "Ajouter des Identifiants API",
    "exchange": "Échange",
    "exchanger": "Échangeur",
    "apiKey": "Clé API",
    "apiSecret": "Secret API",
    "secretKey": "Clé Secrète",
    "passphrase": "Phrase de passe",
    "testConnection": "Tester la Connexion",
    "save": "Sauvegarder les Identifiants",
    "edit": "Modifier",
    "delete": "Supprimer",
    "status": "Statut",
    "connected": "Connecté",
    "disconnected": "Déconnecté",
    "invalid": "Invalide",
    "active": "Actif",
    "testing": "Test en cours...",
    "connectionSuccess": "Connexion réussie",
    "connectionFailed": "Connexion échouée",
    "credentialsAdded": "Identifiants API ajoutés avec succès",
    "credentialsUpdated": "Identifiants API mis à jour avec succès",
    "credentialsDeleted": "Identifiants API supprimés avec succès",
    "connectedTo": "Connecté à",
    "connectionNeedsAttention": "Connexion à",
    "needsAttention": "nécessite une attention",
    "lastUpdated": "Dernière mise à jour",
    "disconnect": "Déconnecter",
    "disconnecting": "Déconnexion...",
    "setAsActive": "Définir comme Actif",
    "activating": "Activation...",
    "autoTrading": "Trading Automatique",
    "enableAutoTradingDesc": "Activer le trading automatisé pour cet échange",
    "add": "Ajouter",
    "update": "Mettre à jour",
    "connectionValidated": "Connexion validée !",
    "autoTradingStatusChanged": "Le trading automatique a été",
    "credentialAddedLimitReached": "Identifiant ajouté (limite atteinte)",
    "requiredMarketType": "Type de Marché Requis",
    "updateCredentialsMessage": "Veuillez mettre à jour vos identifiants API pour continuer le trading",
    "tier2LimitReached": "Limite Niveau 2 atteinte : jusqu'à deux identifiants CEX autorisés.",
    "marketTypes": {
      "futures": "Futures",
      "spot": "Spot",
      "binanceNote": "Trading de futures - effet de levier jusqu'à 125x disponible",
      "binanceUsNote": "Trading spot avec marge - effet de levier jusqu'à 3x disponible",
      "krakenNote": "Trading de futures - effet de levier jusqu'à 100x disponible",
      "bybitNote": "Trading de futures - effet de levier jusqu'à 100x disponible",
      "hyperliquidNote": "Trading de futures perpétuels - effet de levier jusqu'à 50x disponible",
      "standardNote": "Trading spot standard",
    },
    "errors": {
      "loadFailed": "Échec du chargement des identifiants",
      "keysRequired": "Clé API et Clé Secrète requises",
      "tierUndetermined": "Impossible de déterminer le niveau utilisateur",
      "tier1Limit": "Niveau 1 permet seulement un identifiant API",
      "tier2PerCex": "Niveau 2 permet seulement un identifiant par CEX",
      "tier2Limit": "Niveau 2 permet jusqu'à deux identifiants (un par CEX)",
      "tier3Limit": "Niveau 3 permet seulement un identifiant pour tous les CEX",
      "saveFailed": "Échec de la sauvegarde",
      "validationFailed": "Échec de la validation",
      "activationFailed": "Échec de l'activation",
      "deactivationFailed": "Échec de la désactivation",
      "noCredentials": "Aucun identifiant trouvé pour cet échange",
      "autoTradingUpdateFailed": "Échec de la mise à jour du trading automatique",
      "autoTradingUpdateFailedDesc": "Impossible de mettre à jour les paramètres de trading automatique",
    },
    "success": {
      "credentialsSaved": "Identifiants sauvegardés",
      "connectionSuccessful": "Connexion réussie",
      "activated": "Activé",
      "deactivated": "Désactivé",
      "autoTradingEnabled": "Trading automatique activé",
      "autoTradingDisabled": "Trading automatique désactivé",
    }
  },
  "referrals": {
    "title": "Tableau de Bord des Parrainages",
    "loading": "Chargement du tableau de bord des parrainages...",
    "referralLink": "Lien de Parrainage",
    "referralLinkDescription": "Partagez ce lien pour gagner {{rate}}% des paiements de partage des bénéfices de vos parrainages.",
    "tierNames": {
      "tier1": "Niveau 1",
      "tier2": "Niveau 2",
      "tier3": "Niveau 3"
    },
    "settings": {
      "title": "Paramètres",
      "referralSettings": "Paramètres de Parrainage",
      "solanaWalletAddress": "Adresse du Portefeuille Solana",
      "walletPlaceholder": "Entrez l'adresse de votre portefeuille Solana pour les paiements",
      "minimumPayoutAmount": "Montant Minimum de Paiement ($)",
      "enableAutomaticPayments": "Activer les paiements automatiques",
      "autoPaymentEnabled": "Lorsqu'activé, vous recevrez automatiquement les paiements de parrainage lorsqu'ils sont dus.",
      "autoPaymentDisabled": "Lorsque désactivé, vous ne recevrez aucun paiement de parrainage jusqu'à ce que cela soit réactivé.",
      "saveSettings": "Enregistrer les Paramètres",
      "importantWarning": "Avertissement Important :",
      "warnings": {
        "ensureCorrectAddress": "Veuillez vous assurer que l'adresse de votre portefeuille Solana est correcte",
        "doubleCheckAddress": "Vérifiez deux fois l'adresse avant de sauvegarder",
        "notResponsible": "DeepTrade n'est PAS responsable des paiements envoyés à des adresses incorrectes ou invalides",
        "cannotRecover": "Les fonds perdus en raison d'adresses incorrectes ne peuvent pas être récupérés"
      },
      "minimumPayoutRequirements": "Exigences de Paiement Minimum :",
      "requirements": {
        "minimumAmount": "Montant minimum de paiement : $10.00 USDT",
        "gasFeeDeducted": "Les frais de gas du réseau Solana seront déduits du paiement",
        "estimatedGasFee": "Frais de gas estimés : ~0.001 SOL (~$0.10-$0.50)",
        "payoutsProcessed": "Les paiements sont traités en USDT sur le réseau Solana"
      }
    },
    "overview": {
      "totalReferrals": "Total des Parrainages",
      "activeCount": "{{count}} actifs",
      "totalEarnings": "Gains Totaux",
      "totalPaid": "${{amount}} payés",
      "pendingPayout": "Paiement en Attente",
      "requestPayout": "Demander un Paiement",
      "earningRate": "Taux de Gains"
    },
    "actions": {
      "copy": "Copier",
      "generateNew": "Générer Nouveau"
    },
    "recentActivity": {
      "recentReferrals": "Parrainages Récents",
      "recentEarnings": "Gains Récents",
      "noReferrals": "Pas encore de parrainages. Commencez à partager votre lien !",
      "noEarnings": "Pas encore de gains. Les parrainages doivent commencer à trader !",
      "earned": "${{amount}} gagnés"
    },
    "status": {
      "verified": "Vérifié",
      "pending": "En Attente",
      "paid": "Payé"
    },
    "messages": {
      "copied": "Copié !",
      "linkCopied": "Lien de parrainage copié dans le presse-papiers",
      "newCodeGenerated": "Nouveau code de parrainage généré",
      "profileUpdated": "Profil mis à jour avec succès",
      "payoutRequestSubmitted": "Demande de paiement soumise"
    },
    "errors": {
      "failedToLoadData": "Échec du chargement des données de parrainage",
      "failedToGenerateCode": "Échec de la génération du nouveau code",
      "invalidMinimumPayout": "Paiement Minimum Invalide",
      "minimumPayoutRequired": "Le paiement minimum doit être d'au moins $10.00",
      "invalidWalletAddress": "Adresse de Portefeuille Invalide",
      "validWalletRequired": "Veuillez entrer une adresse de portefeuille Solana valide",
      "failedToUpdateProfile": "Échec de la mise à jour du profil",
      "failedToRequestPayout": "Échec de la demande de paiement"
    }
  },

  "paperTradingHelp": {
    "title": "Guide du Trading de Démonstration",
    "whatIsPaperTrading": "Qu'est-ce que le Trading de Démonstration ?",
    "whatIsPaperTradingDesc": "Le trading de démonstration est un environnement de trading simulé qui vous permet de pratiquer des stratégies de trading en utilisant de l'argent virtuel au lieu de fonds réels. C'est le moyen parfait de tester notre système de trading IA sans aucun risque financier.",
    "keyBenefits": "Avantages Clés",
    "riskFree": "Apprentissage Sans Risque",
    "riskFreeDesc": "Pratiquez avec des fonds virtuels - aucun argent réel en risque",
    "realMarketData": "Données de Marché Réelles",
    "realMarketDataDesc": "Expérimentez les conditions de marché en direct et les mouvements de prix",
    "aiTradingSystem": "Système de Trading IA",
    "aiTradingSystemDesc": "Testez nos signaux IA avancés dans un environnement sûr",
    "buildConfidence": "Construire la Confiance",
    "buildConfidenceDesc": "Développez vos compétences de trading avant d'utiliser de l'argent réel",
    "howItWorks": "Comment ça Marche",
    "step1": "Basculer en Mode Démonstration",
    "step1Desc": "Basculez le commutateur de mode de trading pour activer le trading de démonstration",
    "step2": "Solde Virtuel",
    "step2Desc": "Commencez avec un solde virtuel de 10 000 $ (peut être réinitialisé)",
    "step3": "Signaux IA",
    "step3Desc": "Notre IA génère des signaux de trading basés sur des données de marché réelles",
    "step4": "Trades Simulés",
    "step4Desc": "Les trades sont exécutés virtuellement - suivez votre performance",
    "importantNotes": "Notes Importantes",
    "noRealMoney": "Pas d'Argent Réel",
    "noRealMoneyDesc": "Le trading de démonstration utilise uniquement des fonds virtuels. Aucun profit ou perte réel ne se produit.",
    "noRealFees": "Pas de Frais Réels",
    "noRealFeesDesc": "Les frais de trading et le slippage sont simulés pour une expérience réaliste.",
    "performanceTracking": "Suivi des Performances",
    "performanceTrackingDesc": "Toutes les statistiques et analyses sont basées uniquement sur des trades simulés.",
    "readyToStart": "Prêt à Commencer ?",
    "readyToStartDesc": "Basculez le commutateur \"Mode de Trading\" sur \"Démonstration\" et commencez à pratiquer avec des fonds virtuels dès aujourd'hui !",
    "buildConfidenceFooter": "💪 Construisez votre confiance avec le trading de démonstration avant de risquer de l'argent réel !",
    "resetModal": {
      "title": "Réinitialiser le Compte de Trading de Démonstration",
      "warning": "Attention : Cette action ne peut pas être annulée",
      "warningDesc": "Cela supprimera définitivement tout votre historique de trading de démonstration et réinitialisera votre solde virtuel.",
      "resetLimitReached": "Limite de Réinitialisation Quotidienne Atteinte",
      "resetLimitReachedDesc": "Vous avez utilisé les 3 réinitialisations pour aujourd'hui. La limite se remet à zéro à minuit UTC.",
      "resetsRemaining": "Réinitialisations restantes aujourd'hui : {{count},",
      "currentBalance": "Solde Actuel : {{balance}} $",
      "resetToDefault": "Réinitialiser à 10 000 $ par défaut",
      "customBalance": "Définir un solde personnalisé",
      "customBalanceDesc": "Entrez un solde de départ personnalisé (minimum 1 000 $)",
      "confirmationRequired": "Tapez 'RESET' pour confirmer",
      "confirmationPlaceholder": "Tapez RESET ici...",
      "confirmationRequiredError": "Veuillez taper 'RESET' pour confirmer",
      "invalidBalance": "Solde Invalide",
      "invalidBalanceDesc": "Veuillez entrer un montant de solde positif valide",
      "resetting": "Réinitialisation...",
      "resetButton": "Réinitialiser le Compte",
    },
    "howItWorksModal": {
      "title": "Comment Fonctionne le Trading de Démonstration",
      "step1": "Commencez avec un solde virtuel de 10 000 $ (configurable)",
      "step2": "Activez le trading automatique pour que l'IA exécute les trades automatiquement",
      "step3": "Surveillez les performances et ajustez les paramètres de risque selon les besoins",
      "step4": "Passez au trading en direct lorsque vous avez confiance dans le système",
    },
    "importantNotesDetails": {
      "noRealMoneyTitle": "Pas d'Argent Réel :",
      "noRealMoneyDesc": "Le trading de démonstration utilise uniquement des fonds virtuels. Aucun profit ou perte réel ne se produit.",
      "noFeesTitle": "Pas de Frais :",
      "noFeesDesc": "Le trading de démonstration ne génère pas de frais de partage des bénéfices car aucun profit réel n'est réalisé.",
      "resetLimitTitle": "Limite de Réinitialisation :",
      "resetLimitDesc": "Vous pouvez réinitialiser votre compte de démonstration jusqu'à 3 fois par jour.",
    },
    "benefits": {
      "title": "Avantages du Trading de Démonstration",
      "riskFreeLearning": "Apprentissage Sans Risque",
      "riskFreeLearningDesc": "Pratiquez sans perdre d'argent réel tout en apprenant comment fonctionne notre système d'IA",
      "strategyTesting": "Test de Stratégies",
      "strategyTestingDesc": "Testez différents paramètres de risque et voyez comment ils fonctionnent dans le temps",
      "realMarketData": "Données de Marché Réelles",
      "realMarketDataDesc": "Utilise les prix du marché en direct et de vraies prévisions ML pour une expérience authentique",
    },
    "gettingStarted": {
      "title": "Prêt à Commencer ?",
      "description": "Basculez l'interrupteur \"Mode de Trading\" sur \"Démonstration\" et commencez à pratiquer avec des fonds virtuels dès aujourd'hui !",
      "buildConfidenceFooter": "💪 Construisez votre confiance avec le trading de démonstration avant de risquer de l'argent réel !",
    },
    "perfectForBeginners": "💡 Parfait pour les débutants et les traders expérimentés qui veulent tester de nouvelles stratégies !",
    "availableToAllTitle": "Disponible pour Tous :",
    "availableToAllDesc": "Le trading de démonstration est disponible pour tous les utilisateurs quel que soit leur niveau de tier.",
    "gotItThanks": "Compris, merci !",
  },

  "paperTradingDashboard": {
    "performance": {
      "title": "Performance du Trading de Démonstration",
      "refresh": "Actualiser",
      "reset": "Réinitialiser",
      "totalReturn": "Rendement Total",
    },

    "errors": {
      "loadFailed": "Échec du chargement des données de trading de démonstration",
    }
  },
  "tradingSignalStatus": {
    "title": "Statut du Signal de Trading",
    "description": "Statut en direct de la diffusion des signaux du système",
    "signalLabel": "Signal",
    "confidenceLabel": "Confiance du Signal IA",
    "lastUpdateLabel": "Dernière màj",
    "errorLoading": "Échec du chargement du statut de trading",
    "signals": {
      "HOLD": "MAINTENIR",
      "BUY": "ACHETER",
      "SELL": "VENDRE",
      "LONG": "Long",
      "SHORT": "Short",
      "long": "Long",
      "short": "Short"
    }
  },
  "tier": {
    "choosePlan": "Choisissez votre plan",
    "membershipStatus": {
      "title": "Statut d'adhésion",
      "active": "Actif",
      "expired": "Expiré",
      "daysRemaining": "Jours restants :",
      "expiresOn": "Expire le :"
    },
    "modals": {
      "activateTier": "Activer le niveau {{tierName}}",
      "confirmActivation": "Êtes-vous sûr de vouloir activer le niveau {{tierName}} ?",
      "confirmTierChange": "Confirmer le changement de niveau",
      "confirmSwitch": "Êtes-vous sûr de vouloir passer au niveau {{tierName}} ?",
      "cancel": "Annuler",
      "activate": "Activer",
      "confirm": "Confirmer"
    },
    "tiers": {
      "starter": {
        "name": "Niveau 1: Débutant",
        "price": "Gratuit",
        "description": "Parfait pour commencer",
        "features": [
          "Signaux de trading de base",
          "Effet de levier jusqu'à 2,5x",
          "Limité à un accès API",
          "40% de frais de participation aux bénéfices"
        ]
      },
      "pro": {
        "name": "Niveau 2: Pro",
        "description": "Pour les traders sérieux",
        "accessInstructions": "Pour accéder à ce niveau, utilisez le bouton portefeuille dans la barre de navigation supérieure pour connecter votre portefeuille Solana et payer pour un accès de 30 jours.",
        "features": [
          "Signaux de trading avancés",
          "Effet de levier jusqu'à 5x",
          "Limité à deux accès API",
          "20% de frais de participation aux bénéfices"
        ]
      },
      "nftElite": {
        "name": "Niveau 3: NFT Elite",
        "price": "À vie",
        "description": "Pour les collectionneurs vérifiés de NFT Capitolchilax.",
        "visitWebsite": "Visitez capitolchilax.com",
        "accessInstructions": "Pour accéder à ce niveau, utilisez le bouton portefeuille dans la barre de navigation supérieure pour vous connecter et vérifier votre éligibilité NFT.",
        "features": [
          "Signaux de trading avancés",
          "Effet de levier jusqu'à 10x",
          "Connexions API illimitées",
          "10% de frais de participation aux bénéfices",
          "Aucun frais d'adhésion mensuel"
        ]
      }
    },
    "status": {
      "currentTier": "Niveau actuel",
      "alreadyUnlocked": "Déjà débloqué",
      "yourCurrentTier": "Votre niveau actuel",
      "currentlyOn": "Vous êtes actuellement sur {{tierName}}"
    },
    "buttons": {
      "paymentRequired": "Paiement requis",
      "connectWallet": "Connecter le portefeuille",
      "nftRequired": "NFT requis",
      "select": "Sélectionner {{tierName}}",
      "activate": "Activer {{tierName}}",
      "payToReactivate": "Payer pour réactiver",
      "payWithToken": "Payer avec {{token}}",
      "connectWalletFirst": "Connecter le portefeuille d'abord",
      "proceedWithPayment": "Procéder au paiement"
    },
    "nft": {
      "verifyingOwnership": "Vérification de la propriété NFT...",
      "nftRequired": "Vous devez posséder un NFT spécifique pour accéder à ce niveau",
      "nftOwned": "Vous possédez un NFT de la collection requise."
    },
    "payment": {
      "thirtyDaysAccess": "Accès 30 jours",
      "thirtyDaysAccessDue": "Accès 30 jours dû",
      "paymentDetails": "Détails du paiement",
      "amount": "Montant :",
      "network": "Réseau :",
      "wallet": "Portefeuille :",
      "connectionStatus": "Statut de connexion :",
      "connected": "Connecté",
      "disconnected": "Déconnecté",
      "processing": "Traitement du paiement",
      "processingDescription": "Veuillez confirmer la transaction dans votre portefeuille et attendre la confirmation...",
      "successful": "Paiement réussi !",
      "successDescription": "Votre paiement a été traité avec succès. Votre niveau sera mis à jour sous peu.",
      "failed": "Échec du paiement",
      "failedDescription": "Une erreur s'est produite lors du traitement de votre paiement. Veuillez réessayer.",
      "tryAgain": "Réessayer",
      "thirtyDaysAccessDescription": "Complétez votre paiement pour un accès de 30 jours pour activer les fonctionnalités Pro.",
      "importantNotes": "Notes importantes",
      "paymentWarnings": [
        "Assurez-vous d'avoir suffisamment de {{token}} dans votre portefeuille",
        "Gardez du SOL pour les frais de transaction (~0,001 SOL)",
        "Le paiement sera traité sur le réseau principal Solana",
        "La transaction est irréversible une fois confirmée"
      ]
    },
    "paymentHistory": {
      "title": "Historique des paiements",
      "profitShare": "Participation aux bénéfices",
      "thirtyDaysAccess": "Accès 30 jours",
      "billingPeriod": "${{amount}} dû pour {{startDate}} - {{endDate}}"
    },
    "errors": {
      "paymentRequired": "Vous devez payer vos frais de participation aux bénéfices en attente (${{amount}}) avant de changer de niveau.",
      "downgradeNotAllowed": "Vous ne pouvez pas rétrograder du niveau {{currentTier}} au niveau {{newTier}}. Vous ne pouvez que passer à des niveaux supérieurs.",
      "downgradeNotAllowedTitle": "Rétrogradation non autorisée",
      "walletConnectionRequired": "Veuillez connecter votre portefeuille Solana pour accéder au niveau 2.",
      "walletConnectionRequiredTitle": "Connexion de portefeuille requise",
      "nftRequired": "Vous devez posséder un NFT spécifique pour accéder à ce niveau.",
      "membershipExpired": "Votre adhésion de niveau 2 a expiré. Vous avez été rétrogradé au niveau Débutant.",
      "membershipExpiredTitle": "Adhésion expirée",
      "walletDisconnected": "Votre statut de niveau a été préservé.",
      "walletDisconnectedTitle": "Portefeuille déconnecté",
      "walletDisconnectedWithDays": "Votre accès de niveau 2 reste actif pour {{days}} jours de plus.",
      "couldNotValidate": "Votre statut de niveau a été préservé. Reconnectez votre portefeuille pour effectuer des paiements.",
      "failedToFetchTier": "Échec de récupération du statut de niveau",
      "errorLoadingTier": "Erreur lors du chargement des informations de niveau",
      "dataFetchError": "Échec de récupération des données de niveau : {{error}}",
      "dataFetchErrorTitle": "Erreur de récupération de données",
      "walletNotConnected": "Veuillez connecter votre portefeuille Solana pour procéder au paiement.",
      "walletNotConnectedTitle": "Portefeuille non connecté",
      "paymentFailed": "Une erreur s'est produite lors du traitement de votre paiement. Veuillez réessayer.",
      "paymentSuccessful": "Votre paiement {{type}} a été traité avec succès !",
      "activationFailed": "Échec de l'activation du niveau. Veuillez réessayer."
    },
    "profitShare": {
      "paymentDueTitle": "Paiement de participation aux bénéfices dû",
      "accountDisabled": "Compte désactivé",
      "status": "Statut de participation aux bénéfices",
      "paymentWasDue": "Le paiement était dû :",
      "paymentDue": "Paiement dû :",
      "nextPaymentDeadline": "Prochaine échéance de paiement :",
      "payNow": "Payer maintenant",
      "payToReactivate": "Payer pour réactiver",
      "overdue": "EN RETARD",
      "accountDisabledMessage": "Compte désactivé - Paiement requis",
      "paymentOverdue": "Paiement en retard",
      "paymentDueSoon": "Paiement bientôt dû",
      "wasDue": "Était dû :",
      "due": "Dû :",
      "youOwe": "Vous devez ${{amount}} en frais de participation aux bénéfices",
      "allCaughtUp": "Aucun frais de participation aux bénéfices en attente - Vous êtes à jour ! 🎉",
      "scheduleInfo": "Les paiements de participation aux bénéfices sont dus chaque samedi à 0h00 GMT",
      "disableWarning": "Les comptes sont désactivés chaque samedi à 0h00 GMT pour les frais impayés",
      "deadlineApproaching": "Échéance de paiement approche",
      "deadlineMessage": "Votre paiement de participation aux bénéfices de ${{amount}} est dû samedi à 0h00 GMT. Votre compte sera automatiquement désactivé si le paiement n'est pas reçu avant l'échéance.",
      "accountTradingDisabled": "Trading de compte désactivé",
      "accountDisabledDescription": "Votre compte de trading est désactivé en raison de frais de participation aux bénéfices en attente. Payez ${{amount}} pour réactiver le trading.",
      "accountSuspendedWarning": "⚠️ Votre compte a été désactivé en raison de frais impayés. Le trading est suspendu jusqu'au paiement.",
      "disabledOn": "Désactivé le :",
      "deadline": "Échéance :"
    },
    "coupon": {
      "redeemButton": "Vous avez un coupon ? Échangez-le ici",
      "redeemDescription": "Améliorez votre niveau instantanément avec un code de coupon"
    },
    "pricing": {
      "free": "Gratuit",
      "lifetime": "À vie",
      "thirtyDayAccess": "${{price}} pour un accès de 30 jours"
    },
    "success": {
      "tierUpdated": "Votre niveau a été mis à jour vers {{tierName}}.",
      "tierActivated": "Votre niveau a été mis à jour avec succès.",
      "paymentSuccessful": "Votre paiement {{type}} a été traité avec succès !"
    },
    "notifications": {
      "accountDisabled": {
        "title": "🚫 Compte désactivé",
        "description": "Votre compte a été désactivé en raison de frais de participation aux bénéfices impayés de ${{amount}}. Veuillez effectuer un paiement pour réactiver votre compte."
      },
      "paymentOverdue": {
        "title": "⚠️ Paiement en retard",
        "description": "Votre paiement de participation aux bénéfices de ${{amount}} est en retard. Votre compte pourrait être désactivé bientôt."
      },
      "paymentReminder": {
        "title": "⏰ Rappel de paiement",
        "description": "Votre paiement de participation aux bénéfices de ${{amount}} est dû samedi 0h00 GMT. Veuillez payer pour éviter la suspension du compte."
      }
    }
  },
  "help": {
    "title": "Aide & Support",
    "description": "Trouvez des réponses aux questions courantes, consultez nos politiques légales et contactez notre équipe de support.",
    "faqTab": "FAQ",
    "legalTab": "Légal",
    "contactTab": "Contact",
    "faqSection": {
      "categories": {
        "general": "Général",
        "trading": "Trading",
        "tiers": "Niveaux",
        "setup": "Configuration",
        "security": "Sécurité",
        "billing": "Facturation"
      },
      "items": {
        "whatIsDeepTrade": {
          "question": "Qu'est-ce que DeepTrade ?",
          "answer": "DeepTrade est une plateforme de trading de cryptomonnaies alimentée par l'IA qui fournit des signaux de trading automatisés et des outils de gestion de portefeuille utilisant des algorithmes d'apprentissage automatique avancés."
        },
        "howSignalsWork": {
          "question": "Comment fonctionnent les signaux de trading ?",
          "answer": "Notre IA analyse les données de marché en temps réel pour générer des signaux d'achat/vente avec des points d'entrée, des stop losses et des niveaux de prise de bénéfices. Vous pouvez les exécuter manuellement ou activer le trading automatique."
        },
        "tierLevels": {
          "question": "Quels sont les différents niveaux de tier ?",
          "answer": "Tier 1 (Gratuit) : Signaux de base. Tier 2 (50$/mois) : Signaux avancés + trading automatique. Tier 3 (NFT requis) : Fonctionnalités premium + support prioritaire."
        },
        "connectExchange": {
          "question": "Comment connecter mon compte d'exchange ?",
          "answer": "Allez dans Identifiants API dans votre tableau de bord, ajoutez vos clés API d'exchange (lecture seule recommandée), et notre système validera la connexion."
        },
        "dataSecure": {
          "question": "Mes données sont-elles sécurisées ?",
          "answer": "Oui, nous utilisons un chiffrement standard de l'industrie, ne stockons jamais vos clés privées, et recommandons l'accès API en lecture seule pour une sécurité maximale."
        },
        "profitShares": {
          "question": "Comment fonctionnent les participations aux bénéfices ?",
          "answer": "Pour les utilisateurs Tier 2+, nous facturons un petit pourcentage des bénéfices générés par nos signaux. Cela aligne nos intérêts avec votre succès."
        },
        "cancelSubscription": {
          "question": "Puis-je annuler mon abonnement à tout moment ?",
          "answer": "Oui, vous pouvez rétrograder ou annuler votre abonnement à tout moment. Vous conserverez l'accès jusqu'à la fin de votre période de facturation actuelle."
        },
        "supportedExchanges": {
          "question": "Quels exchanges sont supportés ?",
          "answer": "Nous supportons actuellement les principales exchanges incluant Binance, Coinbase Pro, Kraken, et d'autres. Consultez notre page Identifiants API pour la liste complète."
        }
      }
    },
    "legal": {
      "documents": "Documents Légaux",
      "englishNotice": "Toujours affiché en anglais pour la clarté légale",
      "privacy": {
        "title": "Politique de Confidentialité",
        "description": "Notre Politique de Confidentialité décrit comment nous collectons, utilisons et protégeons vos informations personnelles lorsque vous utilisez les services de DeepTrade. Nous nous engageons à maintenir la confidentialité et la sécurité de vos données.",
        "highlights": {
          "title": "Points Clés de Confidentialité :",
          "item1": "Nous collectons uniquement les informations nécessaires pour fournir nos services",
          "item2": "Vos données de trading sont chiffrées et stockées en sécurité",
          "item3": "Nous ne vendons jamais vos informations personnelles à des tiers",
          "item4": "Vous avez le contrôle sur vos données et paramètres de confidentialité"
        },
        "viewFull": "Voir la Politique de Confidentialité Complète"
      },
      "terms": {
        "title": "Conditions de Service",
        "description": "Nos Conditions de Service régissent votre utilisation de la plateforme et des services de DeepTrade. En utilisant notre plateforme, vous acceptez ces termes et conditions.",
        "highlights": {
          "title": "Points Clés des Conditions :",
          "item1": "Droits et restrictions d'utilisation de la plateforme",
          "item2": "Responsabilités et obligations de l'utilisateur",
          "item3": "Disponibilité et limitations du service",
          "item4": "Politiques de résiliation et de suspension de compte"
        },
        "viewFull": "Voir les Conditions de Service Complètes"
      },
      "risks": {
        "title": "Divulgation des Risques"
      }
    },
    "contact": {
      "title": "Contacter le Support",
      "form": {
        "name": "Nom",
        "email": "Email",
        "subject": "Sujet",
        "message": "Message",
        "sendMessage": "Envoyer le Message",
        "sending": "Envoi...",
        "placeholders": {
          "name": "Votre nom complet",
          "email": "votre.email@exemple.com",
          "subject": "Brève description de votre problème",
          "message": "Veuillez décrire votre problème en détail..."
        }
      },
      "guidelines": {
        "title": "Directives de Support",
        "before": {
          "title": "Avant de Contacter le Support",
          "item1": "Consultez d'abord cette section FAQ",
          "item2": "Vérifiez les paramètres de votre compte",
          "item3": "Vérifiez vos identifiants API",
          "item4": "Consultez notre page de statut pour les problèmes connus"
        },
        "when": {
          "title": "Lors du Contact avec le Support",
          "item1": "Incluez l'email de votre compte",
          "item2": "Décrivez le problème en détail",
          "item3": "Fournissez des captures d'écran si applicable",
          "item4": "Incluez les messages d'erreur"
        },
        "notice": {
          "title": "Avis Important",
          "message": "Nous ne demanderons jamais vos clés privées, mots de passe ou clés secrètes API. Gardez ces informations sécurisées et ne les partagez jamais avec personne."
        }
      },
      "errors": {
        "missingInformation": "Informations Manquantes",
        "fillAllFields": "Veuillez remplir tous les champs avant de soumettre.",
        "failedToSend": "Échec de l'envoi du message",
        "error": "Erreur",
        "tryAgainLater": "Échec de l'envoi du message. Veuillez réessayer plus tard."
      },
      "success": {
        "messageSent": "Message Envoyé !",
        "thankYou": "Merci de nous avoir contactés. Nous vous répondrons dans les 24-48 heures."
      }
    }
  },
  "redeemCoupon": {
    "title": "Échanger un Coupon",
    "subtitle": "Entrez votre code de coupon pour améliorer votre niveau",
    "currentTier": "Niveau Actuel:",
    "couponCode": "Code de Coupon",
    "placeholder": "Entrez le code de coupon (ex. DTABC123)",
    "formatHint": "Le code doit contenir 4-20 caractères, lettres et chiffres uniquement",
    "redeemButton": "Échanger le Coupon",
    "redeeming": "Échange en cours...",
    "backToTier": "← Retour à la Gestion des Niveaux",
    "tierNames": {
      "starter": "Débutant (Gratuit)",
      "pro": "Pro (Premium)",
      "vip": "VIP (Elite)",
      "unknown": "Inconnu"
    },
    "howItWorks": {
      "title": "Comment ça marche:",
      "steps": [
        "Entrez votre code de coupon ci-dessus",
        "Votre niveau sera mis à jour automatiquement",
        "Vous obtiendrez un accès immédiat aux nouvelles fonctionnalités",
        "Chaque coupon ne peut être utilisé qu'une seule fois"
      ]
    },
    "errors": {
      "invalidInput": "Entrée Invalide",
      "enterCouponCode": "Veuillez entrer un code de coupon",
      "invalidFormat": "Format Invalide",
      "formatRequirement": "Le code de coupon doit contenir 4-20 caractères, lettres et chiffres uniquement",
      "redemptionFailed": "Échange Échoué",
      "failedToRedeem": "Échec de l'échange du coupon",
      "networkError": "Erreur Réseau",
      "connectionFailed": "Échec de la connexion au serveur. Veuillez réessayer."
    },
    "success": {
      "redeemed": "Coupon Échangé avec Succès!",
      "validFor": "(Valide pour {{days}} jours)"
    }
  },
  "oauthCallback": {
    "loading": {
      "title": "Authentification...",
      "description": "Veuillez patienter pendant que nous terminons votre authentification."
    },
    "error": {
      "title": "Erreur d'Authentification",
      "returnToLogin": "Retour à la Connexion",
      "tryAgain": "Réessayer"
    },
    "completing": {
      "title": "Finalisation de l'Authentification",
      "description": "Veuillez patienter pendant que nous vous connectons..."
    },
    "errors": {
      "authenticationFailed": "Échec de l'authentification",
      "noAuthorizationCode": "Aucun code d'autorisation reçu du fournisseur OAuth",
      "invalidServerResponse": "Réponse invalide du serveur",
      "unexpectedError": "Une erreur inattendue s'est produite lors de l'authentification",
      "noAdditionalDetails": "Aucun détail supplémentaire disponible"
    }
  },
  "resetPassword": {
    "validation": {
      "minLength": "Le mot de passe doit contenir au moins 8 caractères",
      "uppercase": "Le mot de passe doit contenir au moins une lettre majuscule",
      "lowercase": "Le mot de passe doit contenir au moins une lettre minuscule",
      "number": "Le mot de passe doit contenir au moins un chiffre",
      "specialChar": "Le mot de passe doit contenir au moins un caractère spécial"
    },
    "errors": {
      "invalidToken": "Token Invalide",
      "invalidTokenDescription": "Ce lien de réinitialisation de mot de passe est invalide ou a expiré.",
      "validationFailed": "Validation Échouée",
      "validationFailedDescription": "Échec de la validation du token de réinitialisation. Veuillez réessayer.",
      "fillAllFields": "Veuillez remplir tous les champs",
      "passwordsDoNotMatch": "Les mots de passe ne correspondent pas",
      "requirementsNotMet": "Exigences de Mot de Passe Non Respectées",
      "resetFailed": "Échec de la réinitialisation du mot de passe",
      "resetFailedTitle": "Réinitialisation Échouée"
    },
    "success": {
      "title": "Réinitialisation de Mot de Passe Réussie",
      "description": "Votre mot de passe a été mis à jour avec succès.",
      "passwordUpdated": "✓ Mot de Passe Mis à Jour",
      "securityNote": "Vous pouvez maintenant vous connecter avec votre nouveau mot de passe. Pour des raisons de sécurité, vous avez été déconnecté de tous les appareils.",
      "continueToLogin": "Continuer vers la Connexion"
    },
    "validating": {
      "title": "Validation du Lien de Réinitialisation",
      "description": "Veuillez patienter pendant que nous validons votre lien de réinitialisation de mot de passe..."
    },
    "invalid": {
      "title": "Lien de Réinitialisation Invalide",
      "description": "Ce lien de réinitialisation de mot de passe est invalide ou a expiré.",
      "linkInvalid": "Lien Invalide",
      "reason1": "• Le lien de réinitialisation a peut-être expiré (les liens expirent après 1 heure)",
      "reason2": "• Le lien a peut-être déjà été utilisé",
      "reason3": "• Le lien est peut-être malformé ou incomplet",
      "requestNewLink": "Demander un Nouveau Lien de Réinitialisation",
      "backToLogin": "Retour à la Connexion"
    },
    "form": {
      "title": "Réinitialiser Votre Mot de Passe",
      "description": "Entrez votre nouveau mot de passe pour {{email}}",
      "newPassword": "Nouveau Mot de Passe",
      "newPasswordPlaceholder": "Entrez votre nouveau mot de passe",
      "confirmPassword": "Confirmer le Nouveau Mot de Passe",
      "confirmPasswordPlaceholder": "Confirmez votre nouveau mot de passe",
      "updating": "Mise à Jour du Mot de Passe...",
      "updateButton": "Mettre à Jour le Mot de Passe",
      "backToLogin": "Retour à la Connexion"
    },
    "requirements": {
      "title": "Exigences de Mot de Passe",
      "minLength": "• Au moins 8 caractères",
      "caseLetters": "• Inclure des lettres majuscules et minuscules",
      "number": "• Inclure au moins un chiffre",
      "specialChar": "• Inclure au moins un caractère spécial (!@#$%^&*(),.?\":{}|<>)"
    },
    "expiration": {
      "notice": "Ce lien de réinitialisation expire le {{time}}"
    }
  },
  "twoFAResetRequest": {
    "securityQuestions": {
      "question1": "Quand a eu lieu votre dernier échange réussi ?",
      "question2": "À quel niveau êtes-vous actuellement (1, 2 ou 3) ?",
      "question3": "Quelle plateforme d'échange utilisez-vous principalement ?"
    },
    "errors": {
      "fillRequiredFields": "Veuillez remplir tous les champs obligatoires (email, nom complet et raison)",
      "submitFailed": "Échec de l'envoi de la demande de réinitialisation 2FA",
      "requestFailed": "Demande Échouée"
    },
    "success": {
      "requestSubmitted": "Demande Soumise",
      "title": "Demande Soumise",
      "description": "Votre demande de réinitialisation 2FA a été soumise pour examen.",
      "submittedSuccessfully": "✓ Demande Soumise avec Succès",
      "email": "Email",
      "requestId": "ID de Demande",
      "status": "Statut",
      "pendingReview": "En Attente d'Examen",
      "whatHappensNext": "Que se passe-t-il ensuite ?",
      "step1": "1. Notre équipe de sécurité examinera votre demande et les informations de vérification",
      "step2": "2. Nous pouvons vous contacter pour une vérification supplémentaire si nécessaire",
      "step3": "3. Vous recevrez une notification par email une fois traitée",
      "step4": "4. Si approuvée, votre 2FA sera désactivé et vous pourrez le reconfigurer",
      "backToLogin": "Retour à la Connexion",
      "submitAnother": "Soumettre une Autre Demande"
    },
    "form": {
      "title": "Demande de Réinitialisation 2FA",
      "description": "Perdu l'accès à votre appareil 2FA ? Remplissez ce formulaire pour demander une réinitialisation à notre équipe de sécurité.",
      "securityNotice": "⚠️ Avis de Sécurité Important",
      "notice1": "• Ce processus nécessite un examen manuel par notre équipe de sécurité",
      "notice2": "• Fournissez des informations aussi précises que possible pour accélérer la vérification",
      "notice3": "• Les fausses informations entraîneront le rejet de la demande",
      "notice4": "• Temps de traitement : 1-3 jours ouvrables",
      "requiredInformation": "Informations Requises",
      "emailAddress": "Adresse Email *",
      "fullName": "Nom Complet *",
      "reason": "Raison de la Réinitialisation 2FA *",
      "additionalVerification": "Vérification Supplémentaire (Optionnelle mais Recommandée)",
      "lastLoginDate": "Date Approximative de Dernière Connexion",
      "accountCreationDate": "Date Approximative de Création du Compte",
      "recentActivity": "Activité Récente du Compte",
      "securityQuestionsTitle": "Questions de Sécurité",
      "securityQuestionsDescription": "Répondez à ces questions pour aider à vérifier votre identité. Laissez vide si vous ne savez pas.",
      "submittingRequest": "Envoi de la Demande...",
      "submitButton": "Soumettre la Demande de Réinitialisation 2FA",
      "backToLogin": "Retour à la Connexion",
      "rememberDevice": "Vous vous souvenez de votre appareil 2FA ?",
      "tryVerification": "Essayer la vérification 2FA",
      "placeholders": {
        "email": "Entrez l'adresse email de votre compte",
        "fullName": "Entrez votre nom complet tel qu'enregistré",
        "reason": "Expliquez pourquoi vous devez réinitialiser votre 2FA (ex. téléphone perdu, appareil cassé, etc.)",
        "lastLoginDate": "ex. 15 décembre 2024",
        "accountCreationDate": "ex. novembre 2024",
        "recentActivity": "Décrivez les activités récentes (échanges, changements de niveau, paiements, etc.)",
        "yourAnswer": "Votre réponse"
      }
    }
  },
  "verify2FA": {
    "title": "Authentification à Deux Facteurs",
    "description": "Un code de vérification à 6 chiffres a été envoyé à votre adresse email",
    "form": {
      "verificationCode": "Code de Vérification",
      "placeholder": "Entrez le code à 6 chiffres",
      "verifying": "Vérification...",
      "verifyCode": "Vérifier le Code"
    },
    "errors": {
      "sessionExpired": "Session Expirée",
      "pleaseLoginAgain": "Veuillez vous reconnecter.",
      "enterCode": "Veuillez entrer le code de vérification",
      "codeMustBe6Digits": "Le code de vérification doit contenir 6 chiffres",
      "verificationFailed": "Vérification échouée",
      "verificationFailedTitle": "Vérification Échouée",
      "invalidCode": "Code de vérification invalide",
      "failedToResendCode": "Échec du renvoi du code",
      "failedToResendTitle": "Échec du Renvoi"
    },
    "success": {
      "loginSuccessful": "Connexion Réussie",
      "welcomeBack": "Bon retour !",
      "codeSent": "Code Envoyé",
      "codeSentDescription": "Un nouveau code de vérification a été envoyé à votre email."
    },
    "help": {
      "needHelp": "Besoin d'aide ?",
      "sending": "Envoi...",
      "resendCode": "Renvoyer le Code",
      "backToLogin": "Retour à la Connexion",
      "lostDevice": "Appareil 2FA Perdu ? Demander une Réinitialisation",
      "didntReceiveCode": "Vous n'avez pas reçu le code ? Vérifiez votre dossier spam ou",
      "resendIt": "le renvoyer",
      "byContinuing": "En continuant, vous acceptez nos",
      "termsOfService": "Conditions d'Utilisation",
      "privacyPolicy": "Politique de Confidentialité"
    }
  },
  "forgotPassword": {
    "errors": {
      "emailRequired": "L'adresse email est requise",
      "sendFailed": "Échec de l'envoi de l'email de réinitialisation du mot de passe",
      "requestFailed": "Demande Échouée"
    },
    "success": {
      "emailSent": "Email de Réinitialisation Envoyé",
      "title": "Vérifiez Votre Email",
      "description": "Si un compte avec cet email existe, vous recevrez un lien de réinitialisation du mot de passe.",
      "emailSentTitle": "Email Envoyé",
      "emailSentMessage": "Nous avons envoyé un lien de réinitialisation du mot de passe à {{email}} si un compte existe.",
      "instruction1": "• Vérifiez votre dossier spam/courrier indésirable si vous ne voyez pas l'email",
      "instruction2": "• Le lien de réinitialisation expire dans 1 heure",
      "instruction3": "• Vous pouvez demander une autre réinitialisation si nécessaire",
      "sendAnother": "Envoyer un Autre Email de Réinitialisation",
      "backToLogin": "Retour à la Connexion"
    },
    "form": {
      "title": "Mot de Passe Oublié",
      "description": "Entrez votre adresse email et nous vous enverrons un lien pour réinitialiser votre mot de passe.",
      "emailAddress": "Adresse Email",
      "placeholder": "Entrez votre adresse email",
      "sending": "Envoi...",
      "sendResetLink": "Envoyer le Lien de Réinitialisation",
      "backToLogin": "Retour à la Connexion",
      "noAccount": "Vous n'avez pas de compte ?",
      "signUp": "S'inscrire",
      "lost2FA": "Perdu l'accès à votre appareil 2FA ?",
      "request2FAReset": "Demander une réinitialisation 2FA"
    },
    "security": {
      "title": "Note de Sécurité",
      "note1": "• La réinitialisation du mot de passe n'est disponible que pour les comptes traditionnels",
      "note2": "• Les utilisateurs Google OAuth doivent utiliser \"Se connecter avec Google\"",
      "note3": "• Les liens de réinitialisation expirent après 1 heure pour la sécurité"
    }
  }
};
